var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.730469 8.69629C0.730469 8.69629 4.73047 0.696289 11.7305 0.696289C18.7305 0.696289 22.7305 8.69629 22.7305 8.69629C22.7305 8.69629 18.7305 16.6963 11.7305 16.6963C4.73047 16.6963 0.730469 8.69629 0.730469 8.69629Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7305 11.6963C13.3873 11.6963 14.7305 10.3531 14.7305 8.69629C14.7305 7.03943 13.3873 5.69629 11.7305 5.69629C10.0736 5.69629 8.73047 7.03943 8.73047 8.69629C8.73047 10.3531 10.0736 11.6963 11.7305 11.6963Z",
    stroke: "#999999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.5a30f0432919d697a74c2387b99924ed.svg";
export { ForwardRef as ReactComponent };